import TH_AjaxCalls from '_tradeholding/js/Classes/AjaxCalls.js';

let Ajax = new TH_AjaxCalls();

export default Ajax;